module.exports = __webpack_public_path__ + "static/media/buildings.629dfee1.svg";